import { Component, OnInit, DoCheck, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Widget } from '../../models/form';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';


@Component({
  selector: 'app-form-wizard',
  templateUrl: './form-wizard.component.html',
  styleUrls: ['./form-wizard.component.scss']
})
export class FormWizardComponent implements OnInit {

  constructor() { }


  private layouts = {
    "InputText": 50,
    "InputSelect": 50,
    "TextArea": 100,
    "Checkbox": 50,
    "RadioBox": 50,
    "RadioBoxSubtext": 50,
    "HorizontalSelectImage": 100,
    "HorizontalMultiSelectImage": 100,
    "VerticalSelectImageBox": 100,
    "VerticalMultiSelectImageBox": 100,
    "VerticalSelectImage": 100,
    "ComboBox": 100,
    "ComboBoxAddable": 100,
    "ReadOnlyText": 100
  }

  @Input() widgets: Array<Widget>;
  @Input() data: any = {};
  @Input() formGroup: FormGroup;
  @Output() updateData = new EventEmitter();

  private childFormStatut;
  private multidata = {}; //evite la boucle vat et vient avec les combobox





  ngOnInit() {
    console.log(this.widgets);
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("change");
  }
  setData(key, value) {
    console.log(key, value);
    this.data[key] = value;
    this.updateData.emit(this.data);

  }

  selectData(key, value, multiple = false) {
    if (!multiple) {
      if (this.data[key] == value) {
        this.data[key] = null
      }
      else {
        this.data[key] = value;
      }
    }
    else {
      if (!(key in this.data)) {
        this.data[key] = [];
      }
      if (this.data[key].indexOf(value) == -1) {
        this.data[key].push(value)
      }
      else {
        this.data[key].splice(this.data[key].indexOf(value), 1);
      }
    }
    this.updateData.emit(this.data);
  }
  getData(key) {
    if (this.data == null) {
      return null;
    }

    if (key in this.data) {
      return this.data[key];
    }
    else {
      return null;
    }
  }

  getMultiData(widget, index) {
    if (!(index in this.multidata)) {
      this.multidata[index] = {};
      console.log(widget);
      for (let elem of widget.values) {
        if ("param" in elem) {
          let param = elem.param;
          if (param in this.data) {
            this.multidata[index][param] = this.data[param];
          }
        }
        else {//bind 2 lv addable
          for (let elem2 of elem.values) {
            if ("param" in elem2) {
              let param = elem2.param;
              if (param in this.data) {
                this.multidata[index][param] = this.data[param];
              }
            }
            else {
              console.warn("deeper?")
            }
          }
        }

      }
    }
    return this.multidata[index];
  }

  setMultiData(widget, index, data) {

    /*for (let elem of widget.values) {
      let param = elem.param;
      if (param in data) {
        this.data[param] = data[param];
        if (param in this.data) {
          this.multidata[index][param] = this.data[param];
        }
      }

    }*/

    for (let key in data) {
      this.data[key] = data[key];
      this.multidata[index][key] = this.data[key];
    }
    console.log(this.data, this.multidata);
    this.updateData.emit(this.data);

  }

  getDataFromComboBox(widget) {
    if (!(widget.title in this.multidata)) {
      this.multidata[widget.title] = {};
      for (let elem of widget.values) {
        let param = elem.param;
        if (param in this.data) {
          this.multidata[widget.title][param] = this.data[param];
        }

      }
    }
    return this.multidata[widget.title];
  }

  getLayoutsByType(type: string) {
    if (this.layouts.hasOwnProperty(type)) {
      return this.layouts[type];
    }
    else {
      return 50;
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/form-wizard/form-wizard.component.ts